import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Wrench, Inbox, ChevronRight } from 'lucide-react';
import { Card, Avatar } from '../../ui-v2';
import { Badge } from '../../ui-v2.5';
// 3/11 (B2) · las etiquetas de estado, de etiquetasEstado.js (antes, una copia aquí con ui-v2).
import { ESTADO_CITA, etiquetaDe } from '../compartidos/etiquetasEstado';

export default function BloqueProximasCitas({ citas }) {
  const navigate = useNavigate();

  // Agrupar por fecha
  const grupos = {};
  for (const c of citas) {
    if (!grupos[c.fecha]) grupos[c.fecha] = [];
    grupos[c.fecha].push(c);
  }
  const fechasOrdenadas = Object.keys(grupos).sort();
  const hoyISO = todayISO();
  const mananaISO = addDays(hoyISO, 1);

  return (
    <Card className="overflow-hidden p-0 mb-6">
      <div className="px-5 py-4 border-b border-slate-100">
        <h2 className="text-base font-medium text-slate-900">Próximas citas</h2>
        <p className="text-xs text-slate-500 mt-0.5">
          {citas.length === 0
            ? 'Sin citas próximas'
            : `Mostrando las próximas ${citas.length}`}
        </p>
      </div>

      {citas.length === 0 ? (
        <div className="px-5 py-12 text-center">
          <Inbox className="w-8 h-8 mx-auto mb-3 text-slate-300" />
          <p className="text-sm text-slate-500">
            No hay citas reservadas próximamente.
          </p>
        </div>
      ) : (
        <div>
          {fechasOrdenadas.map((fecha) => {
            const esHoy = fecha === hoyISO;
            const esManana = fecha === mananaISO;
            const labelDia = esHoy
              ? 'Hoy'
              : esManana
                ? 'Mañana'
                : formatFechaLarga(fecha);

            return (
              <div key={fecha}>
                <div className={
                  'px-5 py-2 text-[11px] uppercase tracking-wider font-medium border-b border-slate-100 ' +
                  (esHoy ? 'bg-primary/5 text-primary' : 'bg-slate-50 text-slate-500')
                }>
                  {labelDia}
                  <span className="ml-2 normal-case text-slate-400">
                    ({grupos[fecha].length})
                  </span>
                </div>

                <ul className="divide-y divide-slate-100">
                  {grupos[fecha].map((c) => (
                    <FilaCita
                      key={c.id}
                      cita={c}
                      onClick={() => navigate(`/citas-tecnicas/campanas/${c.campana_id}/resumen`)}
                    />
                  ))}
                </ul>
              </div>
            );
          })}
        </div>
      )}
    </Card>
  );
}

function FilaCita({ cita, onClick }) {
  const meta = etiquetaDe(ESTADO_CITA, cita.estado);

  return (
    <li
      onClick={onClick}
      className="px-5 py-3 hover:bg-slate-50/60 cursor-pointer transition-colors"
    >
      <div className="flex items-center gap-4">
        {/* Hora */}
        <div className="shrink-0 w-16 text-right">
          <div className="text-sm font-medium text-slate-900 tabular-nums">
            {cita.hora_inicio}
          </div>
          <div className="text-[10px] text-slate-400 tabular-nums">
            {cita.hora_fin}
          </div>
        </div>

        {/* Usuario */}
        <div className="flex items-center gap-2.5 min-w-0 flex-1">
          <Avatar name={cita.usuario.nombre_completo} size="sm" />
          <div className="min-w-0">
            <div className="text-sm text-slate-900 truncate">
              {cita.usuario.nombre_completo}
            </div>
            <div className="text-[11px] text-slate-500 truncate">
              {cita.campana_titulo}
            </div>
          </div>
        </div>

        {/* Técnico */}
        <div className="hidden sm:flex items-center gap-1.5 shrink-0 text-xs text-slate-600 min-w-[140px]">
          <Wrench className="w-3 h-3 text-slate-400 shrink-0" />
          <span className="truncate">{cita.tecnico.nombre_completo}</span>
        </div>

        {/* Estado */}
        <div className="hidden md:block shrink-0">
          <Badge tone={meta.tone}>{meta.label}</Badge>
        </div>

        <ChevronRight className="w-4 h-4 text-slate-300 shrink-0" />
      </div>
    </li>
  );
}

function todayISO() {
  return new Date().toISOString().slice(0, 10);
}
function addDays(iso, n) {
  const d = new Date(iso + 'T00:00:00');
  d.setDate(d.getDate() + n);
  return d.toISOString().slice(0, 10);
}
function formatFechaLarga(s) {
  if (!s) return '—';
  return new Date(s + 'T00:00:00').toLocaleDateString('es-ES', {
    weekday: 'long', day: 'numeric', month: 'long',
  });
}
